import questionService from '../services/QuestionService';

import { ImageLabelBehavior } from './ImageLabelBehavior';

export class ImageLabelDragDropBehavior extends ImageLabelBehavior {
  setResponseData = (data, _responseAnswer, model, { dataId, lessonElementState, oldDataId } = {}) => {
    if (!lessonElementState.currentResponseAnswer.userInputMap) {
      const userInputMap = questionService.updateUserInputMap({ model, lessonElementState });
      if (dataId) {
        userInputMap.set(dataId, { ...data });
      }
      if (oldDataId) {
        userInputMap.set(oldDataId, {
          dataId: oldDataId,
          text: ''
        });
      }
      return userInputMap;
    } else {
      if (dataId) {
        lessonElementState.currentResponseAnswer.userInputMap.set(dataId, { ...data });
      }
      if (oldDataId) {
        lessonElementState.currentResponseAnswer.userInputMap.set(oldDataId, {
          dataId: oldDataId,
          text: ''
        });
      }
      return lessonElementState.currentResponseAnswer.userInputMap;
    }
  }
}

export default new ImageLabelDragDropBehavior();
